import type {
  UsersMeSettingsPatchRequestBody,
  UsersMeSettingsResponseBody,
} from '@ipfabric/utils';
import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';
import { toggleArrayElement } from 'utils/array/toggleArrayElement';

interface TogglePinnedPageCommand {
  urlPath: string;
}

export const togglePinnedPage: GlobalStateCommandFactory<
  TogglePinnedPageCommand
> = (cmdContext) => async (command) => {
  const pinnedPages = toggleArrayElement(command.urlPath)(
    cmdContext.getState().user.pinnedPages,
  );

  cmdContext.updateState((draft) => {
    draft.user.pinnedPages = pinnedPages;
  });

  await cmdContext.api.request<
    UsersMeSettingsResponseBody,
    UsersMeSettingsPatchRequestBody
  >({
    url: '/users/me/settings',
    method: 'PATCH',
    data: {
      pinnedPages,
    },
  });
};
